import BaseComponent from "../../baseComponent.js";

export default class Empty extends BaseComponent {
  preventDefault(e) {
    e.preventDefault();
  }

  handleDrop(e) {
    //e.preventDefault();
    var data = JSON.parse(e.dataTransfer.getData('data'));
    this.props.handleDrop(data);
  }

  showDropIndicator() {
    $(this.refs.chevron).show();
  }

  hideDropIndicator() {
    $(this.refs.chevron).hide();
  }

  render() {
    var rows = [];
    for (var i = 0; i < this.props.numRows; i++) {
      rows.push(<tr key={i}>
        <td style={{borderLeft: 0}}/>
      </tr>);
    }
    return (
      <div className="spreadsheet-empty-dataset" onDragOver={this.preventDefault}
           onDrop={this.handleDrop}>
        <table ref="table">
          <tbody>
          {rows}
          </tbody>
        </table>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/empty.jsx